<template>
  <b-container>
    <b-form v-if="quickAccess">
      <h3>Schnellzugriff:</h3>
      <hr class="mt-4 mb-4">
      <h4>Titel:</h4>
      <b-form-group>
        <b-input v-model="quickAccess.name"/>
      </b-form-group>
      <h4>Bild:</h4>
      <b-form-group>
        <b-img-lazy style="max-width: 100%" :src="quickAccess.image_url"/>
      </b-form-group>
      <b-input-group class="mt-3">
        <b-form-file
            browse-text="Auswählen"
            v-model="input"
            placeholder="Datei auswählen oder hinein ziehen"
        />
        <b-input-group-append>
          <b-button variant="outline-success" @click="uploadFiles">Hochladen</b-button>
        </b-input-group-append>
      </b-input-group>
      <h4 class="mt-3">Link:</h4>
      <b-form-group>
        <b-input v-model="quickAccess.url"/>
      </b-form-group>
      <hr class="mt-4 mb-4">
      <b-button @click="storeQuickAccess(quickAccess)" fluid variant="outline-success" block>Speichern</b-button>
      <!-- <b-button @click="confirmDeleteQuickAccess" variant="outline-danger" block>Löschen</b-button> -->
    </b-form>
  </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import helpers from "@/helpers";

export default {
  name: 'QuickAccessEdit',
  data() {
    return {
      quickAccessId: parseInt(this.$route.params.quickAccessId),
      input: null,
    }
  },
  computed: {
    ...mapGetters([
      'getStoredQuickAccess'
    ]),
    quickAccess() {
      return this.getStoredQuickAccess
    },
  },
  methods: {
    ...mapMutations([
      'clearQuickAccesses'
    ]),
    ...mapActions([
      'getQuickAccessById',
      'storeQuickAccess',
      'deleteQuickAccess',
      'uploadFile',
    ]),
    confirmDeleteQuickAccess() {
      this.$bvModal.msgBoxConfirm('Wollen Sie den Schnellzugriff wirklich löschen ?', {
        title: 'Löschen',
        okVariant: 'outline-danger',
        okTitle: 'Ja',
        cancelTitle: 'Abbrechen',
        cancelVariant: 'outline-success',
        centered: true
      })
          .then(value => {
            if (value) {
              this.deleteQuickAccess(this.quickAccess)
            }
          })
    },
    uploadFiles() {
      if (!this.input) return helpers.handleWarningMessage("Bitte wählen Sie eine Datei aus.")
      this.uploadFile(this.input).then(response => {
        this.quickAccess.image_url = process.env.VUE_APP_API_URL + response.data
      })
    },
  },
  mounted() {
    this.getQuickAccessById(this.quickAccessId)
  },
  beforeDestroy() {
    this.clearQuickAccesses()
  }
}
</script>

<style scoped>

</style>
